module.exports = {
  rules: {
    // Custom ESLint rules from Gatsby
    "no-anonymous-exports-page-templates": `warn`,
    "limited-exports-page-templates": `warn`,
  },
}
